import { absoluteUrl } from "@rallly/utils/absolute-url";

export const DEFAULT_PRIMARY_COLOR = "#4f46e5";
export const DEFAULT_LOGO_URL = absoluteUrl("/static/logo.svg");
export const DEFAULT_LOGO_URL_DARK = absoluteUrl("/static/logo-dark.svg");
export const DEFAULT_LOGO_ICON_URL = absoluteUrl(
  "/images/rallly-logo-mark.png",
);
export const DEFAULT_APP_NAME = "Rallly";
export const LIGHT_MODE_BACKGROUND = "#ffffff";
export const DARK_MODE_BACKGROUND = "#171717";
